module.exports = __webpack_public_path__ + "static/media/icon_x_pop_up.2425c6c7.svg";